import { Outlet } from 'react-router-dom';
import { Sidebar } from './sidebar';
import { Topbar } from './topbar';
import { EventNotifier } from '@/components/notifications/event-notifier';
import { useVehicleSync } from '@/hooks/use-vehicle-sync';

// =============================================================================
// AppLayout: shell utama webgps — sidebar kiri, topbar atas, konten via Outlet.
// Dipakai oleh semua halaman authenticated (lihat App.tsx routing).
// EventNotifier mendengarkan alarm WS + response command supaya popup (stack
// kanan-atas: menurun, lalu wrap ke kolom kiri) + suara aktif di semua page,
// bukan hanya monitoring.
// =============================================================================

export function AppLayout() {
  // Mount WS → vehicles store sync di shell global. Aktif di semua page
  // authenticated (monitoring/playback/vehicles/dll), bukan cuma /monitoring.
  useVehicleSync();
  return (
    <div className="h-screen w-screen flex bg-background text-foreground overflow-hidden">
      <Sidebar />
      <div className="flex-1 flex flex-col min-w-0">
        <Topbar />
        <main className="flex-1 overflow-hidden">
          <Outlet />
        </main>
      </div>
      <EventNotifier />
    </div>
  );
}
